<div provide-parent-form>
    <div class="main-container">
        <!-- Show thumbnail as background -->
        <div class="channel-group-block">
            <bb-form-element [form]="form" [label]="'SHOW_DETAILPAGE_WITHIN_BORDER' | translate" theme="light-v2-row">
                <mat-slide-toggle [(ngModel)]="channel.detailPageConfig.withinBorder" name="detailPage_withinBorder">
                </mat-slide-toggle>
            </bb-form-element>
        </div>

        <h3>{{ 'PLAYER_OPTIONS' | translate }}</h3>
        <!-- Player alignment -->
        <div class="channel-group-block">
            <div class="channel-group-block no-padding-x no-padding-bottom">
                <bb-form-element [form]="form" [required]="true" theme="light-v2"
                    [label]="'SELECT_PLAYER_ALIGNMENT' | translate" [hideRequiredMark]="true">
                    <bb-radio-list [valueOnlyModel]="true" mode="image" name="detailPage_playerAlignment"
                        [(ngModel)]="channel.detailPageConfig.playerAlignment" [options]="playerAlignmentOptions"
                        [flexGrow]="false" maxColumns="2">
                    </bb-radio-list>
                </bb-form-element>
            </div>
        </div>

        <h3>{{ 'BACKGROUND_OPTIONS' | translate }}</h3>
        <!-- Show thumbnail as background -->
        <div class="channel-group-block">
            <bb-form-element [form]="form" [label]="'SHOW_THUMBNAIL_AS_BACKGROUND' | translate" theme="light-v2-row">
                <mat-slide-toggle [(ngModel)]="channel.detailPageConfig.showThumbnailAsBackground"
                    name="detailPage_showThumbnailAsBackground">
                </mat-slide-toggle>
            </bb-form-element>
        </div>

        <!-- Show background blur -->
        <div class="channel-group-block" *ngIf="!channel.detailPageConfig.showThumbnailAsBackground">
            <bb-form-element [form]="form" [label]="'SHOW_TRANSPARENT_OVERLAY' | translate" theme="light-v2-row">
                <mat-slide-toggle [(ngModel)]="channel.detailPageConfig.enableBackgroundBlur"
                    name="detailPage_enableBackgroundBlur">
                </mat-slide-toggle>
            </bb-form-element>
        </div>

        <!-- Background color picker -->
        <div class="input-with-color-picker"
            *ngIf="!channel.detailPageConfig.enableBackgroundBlur && !channel.detailPageConfig.showThumbnailAsBackground">
            <!-- backgroundColor (preset) -->
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{"BACKGROUND_COLOR" | translate}}</mat-label>
                <span matPrefix><i class="far fa-fill-drip"></i></span>
                <mat-select [(ngModel)]="channel.detailPageConfig.backgroundColor" name="detailPage_backgroundColor">
                    <mat-option *ngFor="let color of backgroundColorPreset" [value]="color.value">
                        {{ color.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- backgroundColor (picker) -->
            <mat-form-field appearance="fill" class="color-width">
                <bb-color-picker-box [(ngModel)]="channel.detailPageConfig.backgroundColor" [pickerPosition]="'left'"
                    [inMatFormField]="true" [excludeHexHash]="true" [hideLabel]="true"
                    name="detailPage_backgroundColor">
                </bb-color-picker-box>
            </mat-form-field>
        </div>

        <h3>{{ 'RELATED_ITEMS' | translate }}</h3>
        <!-- Show related items -->
        <div class="channel-group-block">
            <bb-form-element [form]="form" [label]="'SHOW_RELATED_ITEMS' | translate" theme="light-v2-row">
                <mat-slide-toggle [(ngModel)]="channel.detailPageConfig.showRelatedItems"
                    name="detailPage_showRelatedItems">
                </mat-slide-toggle>
            </bb-form-element>
        </div>
    </div>
</div>
